import { Controller } from "@hotwired/stimulus";

// Shows the first five scenario warnings; "See all" reveals the rest.
export default class extends Controller {
  static targets = ["overflowItem", "expandButton"];

  expand(event) {
    event.preventDefault();

    this.overflowItemTargets.forEach((item) => {
      item.dataset.warningsCollapsed = "false";
      if (item.dataset.warningType !== "volume_mismatch") {
        item.classList.remove("hidden");
      }
    });

    if (this.hasExpandButtonTarget) {
      this.expandButtonTarget.classList.add("hidden");
    }

    window.dispatchEvent(new CustomEvent("scenario-warnings:expand"));
  }
}
